import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";

import EditDiscountLayer from "../../components/restaurants/EditDiscountLayer";


const EditDiscountPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Edit Discount" />

        {/* AddUserLayer */}
        <EditDiscountLayer />


      </MasterLayout>
    </>
  );
};

export default EditDiscountPage;
